<template>
  <section class="space-y-2 p-4">
    <viewTitle title="业务管理 / 报表管理 / 当前装卸点车辆排队情况统计表"/>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="车辆业务类型">
        <el-select clearable v-model="queryParam.business_id" searchable placeholder="请选择">
          <el-option
              v-for="item in business_list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="装卸点">
        <el-select clearable v-model="queryParam.warehouse_id" searchable placeholder="请选择">
          <el-option
              v-for="item in warehouse_list"
              :key="item.id"
              :label="item.name"
              :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button @click="refreshData" type="primary" size="small">刷新数据</el-button>
        <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <c-table
        :data="dataSource"
        :columns="columns"
        :query.sync="pagintion"
        :total="total"
        row-key="id"
        @loadPage="loadData"
    >
    </c-table>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";

export default {
  data() {
    return {
      business_list: [],
      warehouse_list: [],
      columns: [
        {label: "可卸货车辆类型", prop: "business_name"},
        {label: "装卸点", prop: "warehouse_name"},
        {label: "仅装卸比例", prop: "unload_ratio"},
        {label: "取样+装卸比例", prop: "sampling_unload_ratio"},
        {label: "待进厂数量", prop: "state_43"},
        {label: "待取样数量", prop: "state_44"},
        {label: "待装卸或已装卸未离厂", prop: "state_45_46"},
        {label: "合计", prop: "total"},
        {label: "该车辆业务排队占比", prop: "rate"},
        {
          label: "饱和标识", prop: "full", formatData: (row) => row.full ? '已饱和' : '未饱和'
        }
      ],
      fetchDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/warehouse_queue_list",
          data: params
        });
      },
    };
  },
  mixins: [initListMinxin],
  created() {
    this.$common.http({
      url: "/api/queue/admin/query_business",
      data: {
        state: 0,
        keyword: "",
        is_parent: 1,
        page_size: 999
      }
    }).then(res => {
      this.business_list = res.data.data.data;
    });
    this.$common.http({
      url: "/api/queue/admin/query_warehouse",
      data: {
        page_size: 999
      }
    }).then(res => {
      this.warehouse_list = res.data.data.data;
    });
  }
};
</script>
<style lang="less" scoped></style>
